import {
  format,
  parse
} from "./chunk.UO3WNMLX.js";
import {
  uploader_styles_default
} from "./chunk.QPAK2RAY.js";
import {
  isMobile
} from "./chunk.XRUCOIZT.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass,
  __spreadValues
} from "./chunk.K2NRSETB.js";

// src/components/uploader/uploader.ts
import { t as t2 } from "i18next";
var FadvUploader = class extends s {
  constructor() {
    super(...arguments);
    this.isDragging = false;
    this.files = [];
    this.supportsDragAndDrop = false;
    this.errors = [];
    this.acceptsExtensions = [];
    this.acceptsTypes = [];
    this.allowDuplicates = false;
  }
  firstUpdated() {
    const tester = document.createElement("div");
    this.supportsDragAndDrop = "draggable" in tester || "ondragstart" in tester && "ondrop" in tester;
    this.setSubtitle();
  }
  get canDragAndDrop() {
    return !isMobile() && this.supportsDragAndDrop;
  }
  dragEnter(e2) {
    if (!this.canDragAndDrop)
      return;
    e2.preventDefault();
    e2.stopPropagation();
    this.isDragging = true;
  }
  dragExit(e2) {
    if (!this.canDragAndDrop)
      return;
    e2.preventDefault();
    e2.stopPropagation();
    this.isDragging = false;
  }
  drop(e2) {
    var _a, _b;
    if (!this.canDragAndDrop)
      return;
    this.dragExit(e2);
    emit(this, "fadv-file-dropped");
    if (!((_a = e2.dataTransfer) == null ? void 0 : _a.files))
      return;
    if (!e2.dataTransfer.files.length)
      return;
    this.addFiles((_b = e2.dataTransfer) == null ? void 0 : _b.files);
  }
  selectFile() {
    const acceptedFileTypes = [...this.acceptsExtensions, ...this.acceptsTypes];
    if (acceptedFileTypes.length)
      this.fileInput.accept = acceptedFileTypes.join(",");
    emit(this, "fadv-file-selected");
    this.fileInput.click();
  }
  fileSelected() {
    if (!this.fileInput.files)
      return;
    if (!this.fileInput.files.length)
      return;
    this.addFiles(this.fileInput.files);
    this.fileInput.value = "";
  }
  isSelectedFileADuplicate(file) {
    if (!file)
      return false;
    const isDuplicate = this.files.some((f) => {
      return f.name === file.name && f.size === file.size && f.lastModified.toString() === file.lastModified.toString();
    });
    if (isDuplicate) {
      const message = t2("components:uploader.invalidDuplicate", { fileName: file.name });
      this.displayError(message);
    }
    return isDuplicate;
  }
  getAcceptedFileExtensions() {
    return this.acceptsExtensions.map((e2) => e2.replace(/[.]/g, "").toUpperCase());
  }
  getAcceptedFileMimeTypes() {
    return this.acceptsTypes.map((e2) => e2.replace(/\//g, "\u2215"));
  }
  getAcceptedFileTypes() {
    const acceptedFileExtensions = this.getAcceptedFileExtensions();
    const acceptedFileMimeTypes = this.getAcceptedFileMimeTypes();
    return [...acceptedFileExtensions, ...acceptedFileMimeTypes];
  }
  setSubtitle() {
    const accepted = this.getAcceptedFileTypes().join(", ");
    if (accepted.length && this.maxSize) {
      this.subtitle = t2("components:uploader.acceptsFilesSizeLimit", { types: accepted, maxSize: this.maxSize });
    }
    if (accepted.length && !this.maxSize) {
      this.subtitle = t2("components:uploader.acceptsFiles", { types: accepted });
    }
    if (!accepted.length && this.maxSize) {
      this.subtitle = t2("components:uploader.sizeLimit", { maxSize: this.maxSize });
    }
  }
  addFiles(selectedFiles) {
    const files = Array.from({ length: selectedFiles.length }).map((_, index) => selectedFiles.item(index)).filter((file) => this.allowDuplicates || !this.isSelectedFileADuplicate(file)).filter((file) => file && this.files.indexOf(file) < 0).filter((file) => this.isSupportedFile(file)).filter((file) => this.isAcceptableFileSize(file)).filter((file) => !!file).map((file) => file);
    emit(this, "fadv-files-added", { detail: { files } });
    this.files = [...this.files, ...files];
  }
  removeFile(arg) {
    let index;
    if (typeof arg === "number") {
      index = arg;
    } else {
      index = this.files.indexOf(arg);
    }
    this.files = this.files.filter((_, i2) => i2 !== index);
  }
  displayError(message) {
    const error = { id: Date.now(), message };
    const copyOfErrors = this.errors.map((e2) => __spreadValues({}, e2));
    this.errors = [...copyOfErrors, error];
    setTimeout(() => {
      this.errors = this.errors.filter((e2) => e2.id !== error.id);
    }, 3e3);
  }
  isAcceptableFileSize(file) {
    if (!file)
      return false;
    if (!this.maxSize)
      return true;
    const maxFileSize = parse(this.maxSize);
    if (!maxFileSize)
      return true;
    const isAcceptableFileSize = maxFileSize >= file.size;
    if (!isAcceptableFileSize) {
      const message = t2("components:uploader.invalidFileSize", {
        fileName: file.name,
        fileSize: format(file.size),
        maxSize: this.maxSize
      });
      this.displayError(message);
    }
    return isAcceptableFileSize;
  }
  isSupportedFile(file) {
    var _a, _b, _c, _d;
    if (!file)
      return false;
    if ((_a = this.acceptsTypes) == null ? void 0 : _a.length) {
      const isAcceptedType = this.acceptsTypes.some((acceptedType) => {
        let type = acceptedType;
        if (type.indexOf("/*") >= 0) {
          type = type.replace("/*", "");
        }
        return type === file.type;
      });
      if (!isAcceptedType) {
        const message = t2("components:uploader.invalidFileType", {
          fileType: file.type,
          fileName: file.name,
          types: this.getAcceptedFileTypes().join(", ")
        });
        this.displayError(message);
      }
      if (isAcceptedType)
        return true;
    }
    if ((_b = this.acceptsExtensions) == null ? void 0 : _b.length) {
      const fileName = file.name;
      const isAcceptedExtension = this.acceptsExtensions.some((e2) => fileName.endsWith(e2));
      if (!isAcceptedExtension) {
        const extension = file.name.substring(file.name.lastIndexOf("."));
        const message = t2("components:uploader.invalidFileType", {
          fileType: extension,
          fileName: file.name,
          types: this.getAcceptedFileTypes().join(", ")
        });
        this.displayError(message);
      }
      return isAcceptedExtension;
    }
    return !((_c = this.acceptsTypes) == null ? void 0 : _c.length) && !((_d = this.acceptsExtensions) == null ? void 0 : _d.length);
  }
  renderSubtitle() {
    if (!this.subtitle)
      return w;
    return $`<fadv-typography type="label-x-small" variant="neutral" scale="400">${this.subtitle}</fadv-typography>`;
  }
  renderDragAndDropText() {
    if (!this.canDragAndDrop)
      return w;
    return $`<fadv-typography class="uploader__drag-and-drop-label" type="label-small" variant="gray" scale="700" >${t2("components:uploader.dragDropFiles")}</fadv-typography >`;
  }
  renderErrors() {
    if (!this.errors.length)
      return w;
    return $`<div class="uploader__errors">${this.errors.map((error) => $`<fadv-inline-alert variant="danger" bordered rounded>${error.message}</fadv-inline-alert>`)}</div>`;
  }
  render() {
    return $`<div part="base" class=${o({
      uploader: true,
      "uploader--dragging": this.isDragging
    })} ><input class="uploader__file-input" type="file" @change=${this.fileSelected} multiple /><div class="uploader__dropzone" @dragover=${this.dragEnter} @dragenter=${this.dragEnter} @dragleave=${this.dragExit} @dragend=${this.dragExit} @drop=${this.drop} ><fadv-box mv="xxxx-large" pv="x-small"><fadv-box mb="small"><fadv-typography variant="primary"><fadv-icon library="solid" size="medium" name="arrow-up-from-bracket" label=${t2("components:uploader.upload")}></fadv-icon></fadv-typography></fadv-box><fadv-typography type="label-medium" variant="primary" weight="500"><fadv-button variant="text" @click=${this.selectFile}>${t2("components:uploader.selectFiles")}</fadv-button></fadv-typography>${this.renderDragAndDropText()}${this.renderSubtitle()}</fadv-box>${this.renderErrors()}</div><div class="uploader__bars" @fadv-upload-cancelled><slot></slot></div></div>`;
  }
};
FadvUploader.styles = uploader_styles_default;
__decorateClass([
  t()
], FadvUploader.prototype, "isDragging", 2);
__decorateClass([
  t()
], FadvUploader.prototype, "files", 2);
__decorateClass([
  t()
], FadvUploader.prototype, "supportsDragAndDrop", 2);
__decorateClass([
  t()
], FadvUploader.prototype, "subtitle", 2);
__decorateClass([
  t()
], FadvUploader.prototype, "errors", 2);
__decorateClass([
  i(".uploader__file-input")
], FadvUploader.prototype, "fileInput", 2);
__decorateClass([
  e({ attribute: "accepts-extensions", type: Array })
], FadvUploader.prototype, "acceptsExtensions", 2);
__decorateClass([
  e({ attribute: "accepts-types", type: Array })
], FadvUploader.prototype, "acceptsTypes", 2);
__decorateClass([
  e({ attribute: "max-size" })
], FadvUploader.prototype, "maxSize", 2);
__decorateClass([
  e({ type: Boolean, reflect: true, attribute: "allow-duplicates" })
], FadvUploader.prototype, "allowDuplicates", 2);
__decorateClass([
  watch("maxSize"),
  watch("acceptsExtensions"),
  watch("acceptsTypes")
], FadvUploader.prototype, "setSubtitle", 1);
FadvUploader = __decorateClass([
  n("fadv-uploader")
], FadvUploader);

export {
  FadvUploader
};
